import { render } from "./FeatureFlagView.vue?vue&type=template&id=5d6252e8"
import script from "./FeatureFlagView.vue?vue&type=script&lang=js"
export * from "./FeatureFlagView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__